import { RootState } from '../../store/root-state';

const getProjectsState = (state: RootState) => state.projects.projects;

export default getProjectsState;
